<template>
  <v-dialog
    v-model="dialog"
    scrollable
    max-width="60vw"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        color="primary"
        dark
        v-bind="attrs"
        v-on="on"
        small
        @click="editPermissions"
        icon
      >
        <v-icon
          dark
          color="info"
          >mdi-account-edit</v-icon
        >
      </v-btn>
    </template>
    <v-card style="overflow-y: hidden">
      <v-card-title
        primary-title
        class="justify-center"
      >
        <h3 class="headline mb-1 mt-2 ml-2">
          {{ titleText }}
        </h3>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text style="height: 60vh">
        <v-overlay
          absolute
          :value="overlay"
        >
          <v-container style="width: 40vw">
            <v-row
              align-content="center"
              justify="center"
            >
              <v-col cols="6">
                <v-progress-linear
                  indeterminate
                  height="8"
                ></v-progress-linear>
              </v-col>
            </v-row>
          </v-container>
        </v-overlay>
        <v-data-table
          :headers="headers"
          :items="permissionsList"
          v-model="selected"
          item-key="id"
          sort-by="id"
          group-by="actions"
          class="elevation-1"
          checkbox-color="blue"
          fixed-header
          hide-default-footer
          disable-pagination
          show-select
          show-group-by
        ></v-data-table>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-row justify="center">
          <v-container
            justify-space-around
            d-flex
            style="max-width: 50%"
          >
            <v-col md="2">
              <action-button
                @click.native="dialog = false"
                color="secondary"
                label="Close"
                dark
                style="min-width: 100px"
              >
              </action-button>
            </v-col>
            <v-col md="2">
              <action-button
                @click.native="saveChanges"
                color="success"
                label="Save"
                dark
                style="min-width: 100px"
              >
              </action-button>
            </v-col>
          </v-container>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import Vue from 'vue'
  import PermissionsAPI from '@/api/PermissionsAPI'
  import { cloneDeep } from 'lodash'
  import { updateRolePermissions } from '@/api'
  import ActionButton from '@/components/common/actionButton'

  export default Vue.extend({
    components: {
      PermissionsAPI,
      ActionButton,
    },
    props: {},
    data() {
      return {
        headers: [
          {
            text: 'Name',
            align: 'start',
            value: 'name',
            groupable: false,
          },
          { text: 'Actions', value: 'actions', align: 'right', groupable: false },
          { text: 'Description', value: 'description', groupable: false },
        ],
        permissionsList: [],
        selected: [],
        dialog: null,
        overlay: false,
      }
    },
    mounted() {
      this.permissionsList = cloneDeep(this.$store.getters.allPermissions)
    },
    computed: {
      titleText() {
        return this.params.data.name + ' Permissions'
      },
    },
    methods: {
      editPermissions() {
        this.permissionsList = cloneDeep(this.$store.getters.allPermissions)
        const profilePermissions = this.params.data.permissions
        this.selected = this.$store.getters.allPermissions.filter(permission => {
          if (profilePermissions.includes(permission.id)) {
            return permission
          }
        })
        this.overlay = false
      },
      saveChanges() {
        this.overlay = true
        const updatedPermissionsIds = this.selected
          .map(p => {
            return p.id
          })
          .sort((a, b) => (a > b ? 1 : -1))
        let updatedRole = cloneDeep(this.params.data)
        updatedRole.permissions = updatedPermissionsIds
        updateRolePermissions(updatedRole).then(resp => {
          this.params.context.componentParent.updateRoles()
          this.overlay = false
          this.dialog = false
        })
      },
    },
  })
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// EditPermissions.vue?c1b934aa